<template>
  <page-layout :retailer-id="retailerId" active-menu-item="products">
    <main-column :breadcrumbs="breadcrumbs" page-title="Products" content-class="main-column-sub-columns columns">
      <template #header-right v-if="items.length > 0">
        <p class="level-item buttons">
          <b-button type="is-text is-icon" :disabled="selectedItems.length === 0" @click="confirmDeleteBatch">
            <material-icon icon="delete_forever" size="large"></material-icon>
          </b-button>
          <b-button type="is-primary is-rounded" tag="router-link" :to="newProductLink">New Product</b-button>
        </p>
      </template>
      <div class="column full-height">
        <div :class="mainColumnContentClasses">
          <empty-list-indicator v-if="showEmptyList"
            header="Currently there are no Products"
            :showButton="true"
            buttonText="New Product"
            :link="newProductLink">
            <template v-slot:text>
              Set up individual products you'd like Nibble to appear on here. Once they're set up, you can create Rules that apply to unique products on your store.
            </template>
          </empty-list-indicator>
          <b-table v-else :data="items" :checked-rows.sync="selectedItems" checkable hoverable>
            <b-table-column field="name" label="Product" v-slot="props" cell-class="link-cell">
              <router-link class="link" :to="itemPath(props.row)">
                <strong>
                  {{ props.row.name }}
                </strong>
              </router-link>
            </b-table-column>
            <b-table-column label="" v-slot="props">
              <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                <template #trigger>
                  <b-button type="is-text is-icon" icon-left="dots-vertical"></b-button>
                </template>
                <b-dropdown-item aria-role="listitem" @click="editItem(props.row)">Edit</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="deleteItem(props.row)">Delete</b-dropdown-item>
              </b-dropdown>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </main-column>
  </page-layout>
</template>

<script>
import PageLayout from '@/components/PageLayout'
import MainColumn from '@/components/MainColumn'
import EmptyListIndicator from '@/components/EmptyListIndicator'
import MaterialIcon from '@/components/MaterialIcon'
import ItemList from '@/utils/mixins/ItemList'

export default {
  name: 'Products',
  mixins: [ItemList],
  components: { PageLayout, MainColumn, EmptyListIndicator, MaterialIcon },
  data () {
    return {
      retailerId: this.$route.params.retailerId != null ? parseInt(this.$route.params.retailerId) : null,
      items: [],
      selectedItems: []
    }
  },
  computed: {
    newProductLink () {
      return `/retailers/${this.retailerId}/products/new`
    },
    listPath () {
      return `/retailers/${this.retailerId}/products`
    },
    listApiPath () {
      return `/retailers/${this.retailerId}/products`
    },
    itemsKey () {
      return 'products'
    },
    itemIdKey () {
      return 'product_id'
    },
    itemName () {
      return 'Product'
    },
    showEmptyList () {
      return this.items.length === 0
    },
    mainColumnContentClasses () {
      var base = ['main-column-content']
      if (this.showEmptyList) {
        return base.concat(['main-column-content-empty'])
      } else {
        return base
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
